import React, { Component, useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { Button } from "antd";
import checkout from "./checkout";
import { useParams, useHistory, useLocation } from "react-router-dom";

import proIcon from "../../images/pricing/pro.png";
import teamIcon from "../../images/pricing/team.png";
import businessIcon from "../../images/pricing/business.png";
import customIcon from "../../images/pricing/custom.png";

import { getPlans } from "../../redux/actions/payment";
import SideBar from "../../components/sidebarGlobal"

import { Switch, Tag } from 'antd';
// const onChange = (checked) => {
//   console.log(`switch to ${checked}`);
// };

const Pricing = () => {
  const dispatch = useDispatch();

  const history = useHistory();
  const checkoutPlan = (planId) => {
    history.push(`/checkout?p=${planId}`);
  };

  const groupPlan = useSelector((state) => state.userReducer.groupPlan);
  let  planType = "";
  let planColor;
  if(groupPlan?.planId == 3){
    planType = "Pro";
    planColor = "#e2a020";
  } else if((groupPlan?.planId == 4)){
    planType = "Team";
    planColor = "#516cf5";
  } else if((groupPlan?.planId == 5)){
    planType = "Business";
    planColor = "#ff7007";
  }
  
  useEffect(() => {
    dispatch(getPlans());
  }, []);

  return (
    <div className="price-page scrollable">
      <div className="tp-title flex-title">
        <h3>Achieve Faster with Supervity pricing plans</h3>
        <p className="cp-text">Current Plan: <Tag bordered={false} color={planColor}>{planType}</Tag></p>
      </div>
      <div className="plan-cols">
       
        <div className={`plan-type pro-plan ${groupPlan?.planId == 3 ? "active-plan" : ""}`}>
        {groupPlan?.planId == 3 ?
          <span className="cp-plan">Current Plan</span>
        : null}
          <img src={proIcon} />
          <h4 style={{ color: "#E2A020" }}>Pro</h4>
          <h2>Free Forever</h2>
          <p>Everything you need to automate individual work</p>
          {/* <button className="btn btn-primary" style={{visibility: 'hidden'}}>Get Started</button> */}
          <ul className="plan-list">
            <li>One Team with unlimited guest users</li>
            <li>Guest users can view and execute skills only​</li>
            <li>5 skill creations and 50 skill executions in total</li>
            <li>Access to free AI & automation templates</li>
            <li>No-code show & tell AI for creating automation skills</li>
            <li>Active community support</li>
          </ul>
        </div>

        <div className={`plan-type team-plan ${groupPlan?.planId == 4 ? "active-plan" : ""}`}>
        {groupPlan?.planId == 4 ?
          <span className="cp-plan">Current Plan</span>
        : null}
          <img src={teamIcon} />
          <h4 style={{ color: "#516cf5" }}>Team</h4>
          {/* <div className="my-switch">
            <p>Monthly</p>
            <Switch onChange={onChange} />
            <p>Yearly</p>
          </div> */}
          <h2>$8/User/Month</h2>
          <p>Achieve faster by collaborating with your team​</p>
          <button className="btn btn-outline" onClick={() => checkoutPlan(4)}>
            Choose
          </button>
          <ul className="plan-list">
            <li>
              Everything in Pro &​ Up to 10 Teams with unlimited guest users​
            </li>
            <li>Collaborative automation​</li>
            <li>
              All skill creators are treated as members and charged individually
            </li>
            <li>Unlimited skill creations​</li>
            <li>100 skill executions per user​</li>
            <li>$0.2/every additional skill execution</li>
            <li>
              Unattended multi device execution support with Scheduling &
              Queuing​
            </li>
            <li>Embedded (In-App) automation add-on</li>
            <li>Publish skills to digital skill hub​</li>
            <li>Team admin panel & controls</li>
            <li>Email, In-app support​</li>
          </ul>
        </div>

        <div className={`plan-type business-plan ${groupPlan?.planId == 5 ? "active-plan" : ""}`}>
        {groupPlan?.planId == 5 ?
          <span className="cp-plan">Current Plan</span>
        : null}
          <img src={businessIcon} />
          <h4 style={{ color: "#ff8554" }}>Business</h4>
          {/* <div className="my-switch">
            <p>Monthly</p>
            <Switch onChange={onChange} />
            <p>Yearly</p>
          </div> */}
          <h2>$19/User/Month</h2>
          <p>Scale with your internal & external stakeholders​</p>
          <button className="btn btn-outline" onClick={() => checkoutPlan(5)}>
            Choose
          </button>
          <ul className="plan-list">
            <li>Everything in Team &​</li>
            <li>Unlimited Teams with unlimited guests​​</li>
            <li>250 skill executions per user​</li>
            <li>$0.2/every additional skill execution​</li>
            <li>Access to premium templates​</li>
            <li>Team usage & ROI analytics​</li>
            <li>Log retention​</li>
            <li>Priority support with SLAs​</li>
          </ul>
        </div>

        <div className="plan-type enterprise-plan">
          <img src={customIcon} />
          <h4 style={{ color: "#3AA0DA" }}>Enterprise</h4>
          {/* <div className="my-switch"></div> */}
          <h2>Custom </h2>
          <p>Advanced controls and support your organization needs​</p>
          <a
            href="https://www.techforce.ai/contact/"
            target="_blank"
            className="btn btn-outline"
          >
            Contact Us
          </a>
          <ul className="plan-list">
            <li>Everything in Business &</li>
            <li>Unlimited skill executions​​</li>
            <li>Organization controls, approvals​</li>
            <li>Custom template creation​</li>
            <li>Enterprise usage ROI analytics​</li>
            <li>Single Sign On​</li>
            <li>Role-based access controls​</li>
            <li>Premium 24*7 support​</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default connect(null, {})(Pricing);
